import Icon from '../components/Icon.vue'

Icon.register({
  'feather-alt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M512 0C460.2 3.6 96.4 38.2 71 287.6 67.9 314.3 66.2 341.1 65 367.9L243.9 189.2C250.1 182.9 260.3 182.9 266.5 189.2S272.8 205.5 266.5 211.8L7 471C-2.3 480.4-2.3 495.6 7 505 16.4 514.3 31.6 514.3 41 505L98.2 447.9C140.2 447.8 182.3 445.4 224.1 440.5 277.6 435.1 321.1 414.1 356.7 384H255.7L402.5 335.1C413.8 320.2 423.9 304.4 433 288H351.8L458.4 234.8C500.3 132.9 510.2 26.3 512 0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/feather-alt.js
// module id = MRq+
// module chunks = 144